import { DomainError } from "../errors/DomainError";

export type OrderId = string;

export class InvalidOrderIdError extends DomainError {
  constructor() {
    super("El identificador de orden no puede estar vacío");
    this.name = "InvalidOrderIdError";
  }
}

export const createOrderId = (raw: string): OrderId => {
  if (!raw) {
    throw new InvalidOrderIdError();
  }

  return raw;
};
